import { Group, Stack, Title, Text, Breadcrumbs, Anchor } from '@mantine/core';
import type { ReactNode } from 'react';

// Breadcrumbs in a SPA navigate via in-app state, not URLs — accept an onClick
// instead of href. (Pre-fix the crumbs used href="#" which caused a no-op jump
// to the top of the page on click.)
type Crumb = { label: string; onClick?: () => void };

// Standard page header: optional breadcrumbs above, title + description on left,
// actions slot on right (e.g. "+ PWA" button). Matches adset.pro's pattern of
// "Aff. Networks / Help" above and "+ Aff. Network" CTA on the right.
export function PageHeader({
  title,
  description,
  crumbs,
  actions,
}: {
  title: string;
  description?: string;
  crumbs?: Crumb[];
  actions?: ReactNode;
}) {
  return (
    <Stack gap="xs" mb="lg">
      {crumbs && crumbs.length > 0 && (
        <Breadcrumbs separator="/" fz="sm" c="dimmed">
          {crumbs.map((c, i) =>
            c.onClick
              ? <Anchor key={i} component="button" type="button" onClick={c.onClick} c="dimmed" underline="hover">{c.label}</Anchor>
              : <Text key={i} c="dimmed">{c.label}</Text>
          )}
        </Breadcrumbs>
      )}
      <Group justify="space-between" align="flex-end" wrap="nowrap">
        <Stack gap={2}>
          <Title order={2} fz={26} fw={700}>{title}</Title>
          {description && <Text c="dimmed" fz="sm">{description}</Text>}
        </Stack>
        {actions && <Group gap="xs">{actions}</Group>}
      </Group>
    </Stack>
  );
}
